<template>
    <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin d-flex flex-column flex-xl-row" @submit.prevent="submit">
        <ValidationProvider v-errors.api tag="div" class="form-group mb-3 mb-xl-0 mr-xl-3" vid="product_number">
            <input v-model="form.product_number" v-focus type="text" class="form-control" maxlength="4" placeholder="#Кнопка">
        </ValidationProvider>

        <ValidationProvider v-errors.api tag="div" class="form-group mb-3 mb-xl-0 mr-xl-3 flex-fill" vid="id">
            <select-product v-model="form.id" :show-recipe="hasLoading" @select="productSelected" />
        </ValidationProvider>

        <ValidationProvider v-feature="'loading'" v-errors.api tag="div" class="form-group mb-3 mb-xl-0 mr-xl-3" vid="max" rules="integer|min_value:1">
            <input v-model="form.max" type="text" class="form-control" placeholder="Вместимость" maxlength="8" :disabled="isRecipe">
        </ValidationProvider>

        <div>
            <button :disabled="invalid || !form.id || !form.product_number" type="submit" class="btn btn-lg-192 btn-primary">Добавить</button>
        </div>
    </ValidationObserver>
</template>

<script>
import SelectProduct from '@/components/SelectProduct'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'

const form = {
    product: null,
    product_number: null,
    max: null,

    id: null
}

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        SelectProduct
    },

    props: {
        hasLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: { ...form }
        }
    },

    computed: {
        isRecipe() {
            return this.form.product && this.form.product.is_composite
        }
    },

    methods: {
        productSelected(product) {
            this.form.product = { ...product }
        },

        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (!isValid) {
                return
            }

            this.$emit('add', { ...this.form })
        },

        mixinApiErrors(errors) {
            mixinApiErrors(this.$refs.obs, errors)
        },

        reset() {
            this.form = { ...form }
            this.$refs.obs.reset()
        }
    }
}
</script>
